import { useMapElement } from '../contextProviders/MapElementProvider';
import OutcomeDetails from '../common/OutcomeDetails';
import screens from '../common/screens';
import SubFlowConfiguration from './SubFlowConfiguration';

/**
 * Handles switching between the subflow configuration screens
 */
const SubFlowRouter = () => {
    const {
        currentScreen,
        mapElement,
        selectedOutcomeIndex,
        setSelectedOutcomeIndex,
        onSwitchScreen,
    } = useMapElement();

    switch (currentScreen) {
        case screens.subflow:
            return <SubFlowConfiguration />;

        case screens.outcome: {
            const selectedOutcome =
                typeof selectedOutcomeIndex === 'number' &&
                mapElement?.outcomes?.[selectedOutcomeIndex]
                    ? mapElement?.outcomes?.[selectedOutcomeIndex]
                    : null;

            return (
                <OutcomeDetails
                    outcome={selectedOutcome}
                    onSave={() => onSwitchScreen(screens.subflow)}
                    onCancel={() => {
                        onSwitchScreen(screens.subflow);
                        setSelectedOutcomeIndex(null);
                    }}
                />
            );
        }

        default:
            return null;
    }
};

export default SubFlowRouter;
